module.exports = __webpack_public_path__ + "img/luxxfolio.f948f715.png";